import Title from 'components/Title';
import React from 'react';
import { Button, Col, Row } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { CartPlus } from 'styled-icons/fa-solid';
import TableSalesChannel from './components/TableSalesChannel';
import { Container } from './styles';

const Users: React.FC = () => {
  const navigate = useNavigate();
  return (
    <Container>
      <Title>Canais de venda</Title>
      <Row>
        <Col xs={12} sm={6}>
          <Button
            variant="outline-primary"
            title="Canais de Venda"
            onClick={() => navigate('addEditSalesChannel')}
          >
            <CartPlus size="20" />
          </Button>
        </Col>
      </Row>
      <br />
      <TableSalesChannel />
    </Container>
  );
};

export default Users;
